import { Dialog, Text, Button, Icon } from "@ui-component-library";

export const ConfirmClosePopup = ({ isOpen, setIsOpen, handleClose }) => {
  return (
    <Dialog isOpen={isOpen} size="small">
      <Dialog.Header>
        <div className="flex w-full justify-between">
          <Text variant="text-lg/leading-none/medium">Vill du avbryta?</Text>
          <Button
            tw
            variant="tertiary"
            size="icon"
            onClick={() => setIsOpen(false)}
          >
            <Icon
              tw
              name="CrossSimple"
              className="color-charcoal-500"
              size="large"
            />
          </Button>
        </div>
      </Dialog.Header>
      <Dialog.Content>
        <Text variant="text-sm/leading-normal/normal">
          Dina ändringar kommer inte att sparas om du avbryter nu.
        </Text>
      </Dialog.Content>
      <Dialog.Footer>
        <Button tw variant="secondary" onClick={() => setIsOpen(false)}>
          Nej, stanna kvar
        </Button>
        <Button tw variant="primary" onClick={handleClose}>
          Ja, stäng
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
};
